import { render } from "./p-multiselect.vue?vue&type=template&id=22c4c732&scoped=true"
import script from "./p-multiselect.vue?vue&type=script&lang=js"
export * from "./p-multiselect.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./p-multiselect.vue?vue&type=style&index=1&id=22c4c732&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c4c732"]])

export default __exports__